
import { defineComponent, watch } from 'vue';
import { usePatientStore } from '@/store/patient';
import Collapsible from '@/components/Collapsible.vue';
import DatePicker from '@/components/DatePicker.vue';
import { useRequestDataStore } from '@/store/request-data';

export default defineComponent({
    components: { Collapsible, DatePicker },

    setup()
    {
        const patient = usePatientStore();
        const requestDataStore = useRequestDataStore();

        watch([() => patient.birthDate, () => patient.gender], () => {
            requestDataStore.populateDataFromDrugAndPatientData();
        });

        return { patient };
    }
})
